import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRotate90Right24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconRotate90Right24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6 13v3.5H5A1.5 1.5 0 0 1 3.5 15V5A1.5 1.5 0 0 1 5 3.5h6A1.5 1.5 0 0 1 12.5 5v5H9a3 3 0 0 0-3 3m-1 5h1v1a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-6a3 3 0 0 0-3-3h-5V5a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3m15.5 1v-6a1.5 1.5 0 0 0-1.5-1.5H9A1.5 1.5 0 0 0 7.5 13v6A1.5 1.5 0 0 0 9 20.5h10a1.5 1.5 0 0 0 1.5-1.5M18.25 2H15.5v1.5h2.75a2.25 2.25 0 0 1 2.25 2.25V8.5H22V5.75A3.75 3.75 0 0 0 18.25 2"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRotate90Right24);
